import { render } from "./AppFormItem.vue?vue&type=template&id=e8dd69a0&scoped=true&ts=true"
import script from "./AppFormItem.vue?vue&type=script&lang=ts"
export * from "./AppFormItem.vue?vue&type=script&lang=ts"

import "./AppFormItem.vue?vue&type=style&index=0&id=e8dd69a0&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8dd69a0"]])

export default __exports__